import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';
import { ROLE } from '../../../lib/constants';

export const MainBlock = styled.div`
  flex: 1 0 auto;
  width: 100%;
  height: 100%;
  align-items: stretch;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px;
`;
export const BodyBlock = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0px 3px 6px ${ColorSF2.transparentShadow};
`;
export const TitleWrapper = styled.div`
  height: 50px;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${ColorSF2.paleBlue};
  padding: 0 10px;
  font-weight: bold;
  @media (max-height: 530px) {
    height: 30px;
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  color: ${ColorSF2.black};
`;

export const ListsWrapper = styled.div`
  width: 100%;
  height: calc(
    100% - ${props => (props.userRole === ROLE.GUEST ? 100 : 150)}px
  );

  @media (max-height: 530px) {
    height: calc(100% - 80px);
  }
`;
export const TitleWrapperFlex = styled.div`
  display: flex;
`;

export const SearchBoxWrapper = styled.div`
  margin-left: 20px;
`;
